import { Controller } from '@hotwired/stimulus'
import { loadScript } from 'util/script'

// Connects to data-controller="google-calendar-connection"
export default class extends Controller {
  static targets = ['provider', 'code', 'scope', 'submit']

  static values = {
    clientId: String
  }

  async connect () {
    await loadScript('google-auth', 'https://accounts.google.com/gsi/client', 'google')
  }

  get client () {
    if (!this._client) {
      const { google } = window

      this._client = google.accounts.oauth2.initCodeClient({
        client_id: this.clientIdValue,
        scope: [
          'https://www.googleapis.com/auth/calendar.readonly',
          'https://www.googleapis.com/auth/calendar.events',
          'https://www.googleapis.com/auth/userinfo.email',
          'https://www.googleapis.com/auth/userinfo.profile'
        ].join(' '),
        ux_mode: 'popup',
        callback: (response) => this.#handleCodeResponse(response)
      })
    }

    return this._client
  }

  signIn () {
    this.client.requestCode()
  }

  #handleCodeResponse (response) {
    this.codeTarget.value = response.code
    this.scopeTarget.value = response.scope
    this.providerTarget.value = 'google'

    this.submitTarget.closest('form').requestSubmit(this.submitTarget)
  }
}
